<template>
    <div>
      <div class="infocontainer" >
        <template v-if="language == 'cn'">
          <div class="title1" data-v-85f2ecf4="">服务条款</div>
          <div class="title2" data-v-85f2ecf4="">1. 同意服务条款</div>
          <div class="content" data-v-85f2ecf4="">本协议（使用条款），包括目前和未来的商业网站和客户。通过使用本服务，无论您是否注册为网站会员（以下简称会员），您都将被视为已同意本使用条款。如果您不同意本服务条款，请停止使用我们的服务。
          </div>
          <div class="title2" data-v-85f2ecf4="">2. 资格要求</div>
          <div class="content" data-v-85f2ecf4="">未满18岁的未成年人不得使用我们的服务。通过使用我们的服务，您声明并保证您有权利和能力遵守使用条款的所有规定。</div>
          <div class="title2" data-v-85f2ecf4="">3. 使用条款变更</div>
          <div class="content" data-v-85f2ecf4="">本网站保留更改本使用条款的权利，恕不另行通知。您可以查看服务条款以定期更改情况。当我们更改使用条款时，如果您使用我们的服务，无论您是否认为您同意这些更改。</div>
          <div class="title2" data-v-85f2ecf4="">4. 隐私</div>
          <div class="content" data-v-85f2ecf4="">我们的网站尊重网站访问者的隐私。使用该服务应遵守我们的隐私政策。我们的网站合作伙伴同意遵守隐私政策的规定. GOVERNING LAW- These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the HK laws.</div>
          <div class="title2" data-v-85f2ecf4="">5. 服务变更</div>
          <div class="content" data-v-85f2ecf4="">我们的网站可以决定添加，删除或修改服务或服务，恕不另行通知。</div>
          <div class="title2" data-v-85f2ecf4="">6. 特色服务</div>
          <div class="title3" data-v-85f2ecf4="">A) 支付</div>
          <div class="content" data-v-85f2ecf4="">支付信息将作为您同意购买的服务产生的费用进行传输，结果将由您与金融机构、信用卡发卡机构或您选择的其他支付服务提供商之间的返回信息决定。如果我们的网站不接受您的支付服务提供商提供的支付服务，您可以支付您需要的所有金额，并同意继续使用我们的服务。如果您的帐户已付款，您可以要求我们取消您的付款状态。一旦您的帐户被取消，您的付款状态将在您的最终付款日期到期。付费状态不可转让。我们网站的付款状态是最终销售，不能退款。会员在当月或季度到期后不会自动扣除持卡人的续费。如果会员想继续使用，需要手动充值。有争议的费用应在您购买服务后60天内报告给我们的网站。如果您对您的付费状态有任何疑问，请联系我们解决。</div>
          <div class="title3" data-v-85f2ecf4="">B) 服务合同</div>
          <div class="content" data-v-85f2ecf4="">您在我们的网站订购服务将不会自动续订。您可以随时联系我们的客户服务团队进行更改或重新订购。如果您选择订购，您的订单将在服务未自动续订时过期。过期前取消定做，无法获得退款。</div>
          <div class="title3" data-v-85f2ecf4="">C)免费试用及其他促销</div>
          <div class="content" data-v-85f2ecf4="">任何免费试用或其他促销方式，均可在特定试用期内定制使用我们的服务。如果用户需要订购促销服务条款，则应在试用期前取消订单，以避免交付定制费用。</div>
          <div class="title2" data-v-85f2ecf4="">7. 通过合作伙伴加入我们的网站</div>
          <div class="content" data-v-85f2ecf4="">如果您通过我们的合作伙伴注册使用我们的服务，我们的网站将与其合作伙伴一起提供服务。您将有权使用会员服务，并有权向我们网站转让您的会员资格或付费向我们网站转让您的账户类似的服务。</div>
          <div class="title2" data-v-85f2ecf4="">8. 社区内容</div>
          <div class="content" data-v-85f2ecf4="">所有服务应遵循社区内容指南的要求。您同意不发布、传输、分发或链接任何涉及非法、骚扰、诽谤、威胁、有害、淫秽、叛逆、诽谤、诽谤他人名誉和侵犯他人隐私的内容，也不向他人发送不高兴的内容，更确切地说是针对其他人权团体或内容。知识产权未经本人书面同意，不得使用他人的知识产权，包括受著作权和商标保护的信息，不得对他人的知识产权进行变更或变更，如非著作权的文字、图片等。我们网站不会对任何由会员或团体发送的邮件内容负责，任何信息、商品或服务均不对第三方或会员负责。使用我们的服务，您同意：在以下情况下，我们的网站将不对您或他人负责：例如：对任何一方的威胁、诽谤、淫秽、猥亵、攻击或冒犯，或侵权，包括非法使用知识产权。我们的网站没有您提供给我们的所有信息（包括反馈和建议），或者您发布我们的网站、下载、输入或提交所有信息（“提交的信息”）。但是，如果您在我们的网站或客户上发布、上传、输入、提供或提交信息，您表示您给予我们的网站永久和不可撤销的转让权，我们的网站有权复制、使用、存储、修改、编辑、翻译或发布您提交的任何或所有信息，而且没有支付版税的信息。我们的网站没有义务发布或使用您提交的信息，我们的网站可以随时决定删除您提交的信息。在本网站中，您下载、输入或提交的信息表明您可以控制信息的发布。对于您的信息被删除、无效或未能保存，我们网站及其合作伙伴将不承担任何责任。</div>
          <div class="title2" data-v-85f2ecf4="">9. 会员账号</div>
          <div class="content" data-v-85f2ecf4="">一旦您注册我们的服务，您将收到一个帐号和密码，您有责任对您的帐号和密码保密，并应负责与您的帐号有关的所有活动。一旦注册成为会员，您将负责您的所有信息文件。禁止在文件或网络服务项目中发布色情或其他淫秽内容，因为这会威胁您的会员资格。对于下线交友网站会员我们网站，我们网站将不承担任何责任。您同意我们网站向您发送邮件（涉及服务信息（包括升级变更）、新功能或事件、使用服务的意见和建议）。</div>
          <div class="title2" data-v-85f2ecf4="">10. 受版权和商标保护的材料</div>
          <div class="content" data-v-85f2ecf4="">我们网站的内容受版权保护© 2011-2022.</div>
          <div class="title2" data-v-85f2ecf4="">11. 免责声明</div>
          <div class="content" data-v-85f2ecf4="">在我们的网站或由我们的网站（或我们的网站代理商或合作伙伴）发布的信息，根据“现有”和“现有”报价。它提供各种明示或暗示的保证和条件。我们的网站不控制第三方提供的任何信息、产品或服务。您明确同意使用本服务将独自承担风险。在适用法律允许的最大范围内：我们网站上所有明示或暗示的保证、免责声明和此类保证，包括但不限于暗示的适销性，并确保适用于特殊用途；我们的网站不保证所提供的服务能满足您的需求，也不保证服务会不间断、及时、安全或正确。我们的网站不用于服务和使用结果作为抵押品。我们的网站不保证本网站或服务不包含任何病毒或其他有害成分。本网站不保证或声明：对网站转让信息保密。我们的网站不保证翻译的准确性和完整性。我们的网站不保证以下内容：通过本网站购买或获得的任何商品或服务，或在本网站上做广告或赞助商品或服务，或通过本网站进行的任何交易。信息我们的网站不是您从我们的网站收到服务或作出任何明示保证（无论是口头或书面）。</div>
        </template>
        <template v-else-if="language == 'tn'">
          <div class="title1" data-v-85f2ecf4="">服務條款</div>
          <div class="title2" data-v-85f2ecf4="">1. 同意服務條款</div>
          <div class="content" data-v-85f2ecf4="">本協定（使用條款），包括現時和未來的商業網站和客戶。通過使用本服務，無論您是否注册為網站會員（以下簡稱會員），您都將被視為已同意本使用條款。如果您不同意本服務條款，請停止使用我們的服務。
          </div>
          <div class="title2" data-v-85f2ecf4="">2. 資格要求</div>
          <div class="content" data-v-85f2ecf4="">未滿18歲的未成年人不得使用我們的服務。通過使用我們的服務，您聲明並保證您有權利和能力遵守使用條款的所有規定。</div>
          <div class="title2" data-v-85f2ecf4="">3. 使用條款的變更</div>
          <div class="content" data-v-85f2ecf4="">本網站保留更改本使用條款的權利，恕不另行通知。您可以查看服務條款以定期更改情况。當我們更改使用條款時，如果您使用我們的服務，無論您是否認為您同意這些更改。</div>
          <div class="title2" data-v-85f2ecf4="">4. 隱私</div>
          <div class="content" data-v-85f2ecf4="">我們的網站尊重網站訪問者的隱私。使用該服務應遵守我們的隱私政策。我們的網站合作夥伴同意遵守隱私政策的規定。</div>
          <div class="title2" data-v-85f2ecf4="">5. 服務變更</div>
          <div class="content" data-v-85f2ecf4="">我們的網站可以决定添加，删除或修改服務或服務，恕不另行通知。</div>
          <div class="title2" data-v-85f2ecf4="">6. 特色服務</div>
          <div class="title3" data-v-85f2ecf4="">A) 付款</div>
          <div class="content" data-v-85f2ecf4="">支付資訊將作為您同意購買的服務產生的費用進行傳輸，結果將由您與金融機構、信用卡髮卡機构或您選擇的其他支付服務提供者之間的返回資訊决定。如果我們的網站不接受您的支付服務提供者提供的支付服務，您可以支付您需要的所有金額，並同意繼續使用我們的服務。如果您的帳戶已付款，您可以要求我們取消您的付款狀態。一旦您的帳戶被取消，您的付款狀態將在您的最終付款日期到期。付費狀態不可轉讓。我們網站的付款狀態是最終銷售，不能退款。會員在當月或季度到期後不會自動扣除持卡人的續費。如果會員想繼續使用，需要手動充值。有爭議的費用應在您購買服務後60天內報告給我們的網站。如果您對您的付費狀態有任何疑問，請聯繫我們解决。</div>
          <div class="title3" data-v-85f2ecf4="">B) 服務合同</div>
          <div class="content" data-v-85f2ecf4="">您在我們的網站訂購服務將不會自動續訂。您可以隨時聯繫我們的客戶服務團隊進行更改或重新訂購。如果您選擇訂購，您的訂單將在服務未自動續訂時過期。過期前取消定做，無法獲得退款。</div>
          <div class="title3" data-v-85f2ecf4="">C)免費試用及其他促銷</div>
          <div class="content" data-v-85f2ecf4="">任何免費試用或其他促銷管道，均可在特定試用期內定制使用我們的服務。如果用戶需要訂購促銷服務條款，則應在試用期前取消訂單，以避免交付定制費用。</div>
          <div class="title2" data-v-85f2ecf4="">7. 通過合作夥伴加入我們的網站</div>
          <div class="content" data-v-85f2ecf4="">如果您通過我們的合作夥伴注册使用我們的服務，我們的網站將與其合作夥伴一起提供服務。您將有權使用會員服務，並有權向我們網站轉讓您的會員資格或付費向我們網站轉讓您的帳戶類似的服務。</div>
          <div class="title2" data-v-85f2ecf4="">8. 社區內容</div>
          <div class="content" data-v-85f2ecf4="">所有服務應遵循社區內容指南的要求。您同意不發佈、傳輸、分發或連結任何涉及非法、騷擾、誹謗、威脅、有害、淫穢、叛逆、誹謗、誹謗他人名譽和侵犯他人隱私的內容，也不向他人發送不高興的內容，更確切地說是針對其他人權團體或內容。知識產權未經本人書面同意，不得使用他人的知識產權，包括受著作權和商標保護的資訊，不得對他人的知識產權進行變更或變更，如非著作權的文字、圖片等。我們網站不會對任何由會員或團體發送的郵件內容負責，任何資訊、商品或服務均不對協力廠商或會員負責。使用我們的服務，您同意：在以下情况下，我們的網站將不對您或他人負責：例如：對任何一方的威脅、誹謗、淫穢、猥褻、攻擊或冒犯，或侵權，包括非法使用知識產權。我們的網站沒有您提供給我們的所有資訊（包括迴響和建議），或者您發佈我們的網站、下載、輸入或提交所有資訊（“提交的資訊”）。但是，如果您在我們的網站或客戶上發佈、上傳、輸入、提供或提交資訊，您表示您給予我們的網站永久和不可撤銷的轉讓權，我們的網站有權複製、使用、存儲、修改、編輯、翻譯或發佈您提交的任何或所有資訊，而且沒有支付版稅的資訊。我們的網站沒有義務發佈或使用您提交的資訊，我們的網站可以隨時决定删除您提交的資訊。在本網站中，您下載、輸入或提交的資訊表明您可以控制資訊的發佈。對於您的資訊被删除、無效或未能保存，我們網站及其合作夥伴將不承擔任何責任。</div>
          <div class="title2" data-v-85f2ecf4="">9. 會員帳戶</div>
          <div class="content" data-v-85f2ecf4="">一旦您注册我們的服務，您將收到一個帳號和密碼，您有責任對您的帳號和密碼保密，並應負責與您的帳號有關的所有活動。一旦注册成為會員，您將負責您的所有資訊檔案。禁止在檔案或網絡服務專案中發佈色情或其他淫穢內容，因為這會威脅您的會員資格。對於下線交友網站會員我們網站，我們網站將不承擔任何責任。您同意我們網站向您發送郵件（涉及服務資訊（包括陞級變更）、新功能或事件、使用服務的意見和建議）。</div>
          <div class="title2" data-v-85f2ecf4="">10. 受版權和商標保護的資料</div>
          <div class="content" data-v-85f2ecf4="">我們網站的內容受版權保護© 2011-2022.</div>
          <div class="title2" data-v-85f2ecf4="">11. 免責聲明</div>
          <div class="content" data-v-85f2ecf4="">在我們的網站或由我們的網站（或我們的網站代理商或合作夥伴）發佈的資訊，根據“現有”和“現有”報價。它提供各種明示或暗示的保證和條件。我們的網站不控制協力廠商提供的任何資訊、產品或服務。您明確同意使用本服務將獨自承擔風險。在適用法律允許的最大範圍內：我們網站上所有明示或暗示的保證、免責聲明和此類保證，包括但不限於暗示的適銷性，並確保適用於特殊用途；我們的網站不保證所提供的服務能滿足您的需求，也不保證服務會不間斷、及時、安全或正確。我們的網站不用於服務和使用結果作為抵押品。我們的網站不保證本網站或服務不包含任何病毒或其他有害成分。本網站不保證或聲明：對網站轉讓資訊保密。我們的網站不保證翻譯的準確性和完整性。我們的網站不保證以下內容：通過本網站購買或獲得的任何商品或服務，或在本網站上做廣告或贊助商品或服務，或通過本網站進行的任何交易。資訊我們的網站不是您從我們的網站收到服務或作出任何明示保證（無論是口頭或書面）。</div>
        </template>
        <template v-else>
          <div class="title1" data-v-85f2ecf4="">TERMS OF USE</div>
          <div class="title2" data-v-85f2ecf4="">1. AGREE TO TERMS OF USE</div>
          <div class="content" data-v-85f2ecf4="">This Agreement (Terms of Use), including present and future business website and the client. By using this service, whether or not you register as a website members (hereinafter referred to as members), you will be deemed to have agreed to these terms of use. If you do not agree to this Terms of Service, please stop using our services.
            <span id="termsp" data-v-85f2ecf4="">Now the site is owned and operated by Jingkun Trading Limited.</span>
          </div>
          <div class="title2" data-v-85f2ecf4="">2. ELIGIBILITY REQUIREMENTS</div>
          <div class="content" data-v-85f2ecf4="">Minors under the age of 18 years shall not use our services. By using our service, you represent and warrant that you have the right and ability to comply with all the provisions of the Terms of Use.</div>
          <div class="title2" data-v-85f2ecf4="">3. CHANGES TO THE TERMS OF USE</div>
          <div class="content" data-v-85f2ecf4="">Our website reserves the right without prior notice, to change these Terms of Use. You can view the Terms of Service to change the situation on a regular basis. When we make changes to the terms of use, if you use our services, whether or not you view that you agree to these changes.</div>
          <div class="title2" data-v-85f2ecf4="">4. PRIVACY</div>
          <div class="content" data-v-85f2ecf4="">Our website respect the privacy of site visitors. Using the service should follow our privacy policy. Our website partners agreed to follow the provisions of the privacy policy. GOVERNING LAW- These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the HK laws.</div>
          <div class="title2" data-v-85f2ecf4="">5. SERVICE CHANGE</div>
          <div class="content" data-v-85f2ecf4="">Our website can decide to add, delete or modify services or the services without prior notice.</div>
          <div class="title2" data-v-85f2ecf4="">6.CUSTOM</div>
          <div class="title3" data-v-85f2ecf4="">A) PAYMENT</div>
          <div class="content" data-v-85f2ecf4="">Payment information will be transmitted as a fee incurred by the service you have agreed to purchase, and the result will be determined by the return information between you and a financial institution, a credit card issuer or other payment service provider of your choice. If our website does not accept payment services provided by your Payment Service Provider, you can pay all the amount you need and agree to continue using our services. If your account has been paid, you can ask us to cancel the status of your payment. Once your account has been cancelled, your payment status will expire on the date of your final payment. The paid status is not transferable. The paid status of Our website is final sales, and no refund can be made. Members will not automatically deduct the cardholder's renewal fee after the expiry of the month or quarter. If members want to continue to use it, they need to recharge it manually. The disputed fee should be reported to Our website within 60 days after you purchase the service. If you have any questions about your paid status, please contact us for settlement.</div>
          <div class="title3" data-v-85f2ecf4="">B) SERVICE CONTRACT</div>
          <div class="content" data-v-85f2ecf4="">You order at Our website site service will not automatically renew. You can contact our customer service team at any time to change or re-ordered. If you choose to order, your order will expire at the service does not automatically renew. Canceled before the expiry custom-made, can not get a refund.</div>
          <div class="title3" data-v-85f2ecf4="">C)FREE TRIAL AND OTHER PROMOTIONAL</div>
          <div class="content" data-v-85f2ecf4="">Any free trial or other promotional methods, can be customized to use our services in a specific trial period. If users need to order promotional service provisions, you should cancel the order before the trial period in order to avoid delivery of custom fees.</div>
          <div class="title2" data-v-85f2ecf4="">7. JOIN OUR WEBSITE THROUGH PARTNERS</div>
          <div class="content" data-v-85f2ecf4="">If you register to use our services through partners Our website, and Our website with its partners to provide the service. You will have the right to use members of the service, and Our website the right to transfer your membership or paid to transfer your account to the Our website similar services.</div>
          <div class="title2" data-v-85f2ecf4="">8. COMMUNITY CONTENT</div>
          <div class="content" data-v-85f2ecf4="">All services should follow the requirements of community content guidelines. You agree not to publish, transmit, distribute or link to anything involving unlawful, harassing, defamatory, threatening, harmful, obscene, rebellious, libel, slander the reputation of others, and violations of the privacy of others of the content, nor send other people unhappy, or rather against other human rights groups or content. Intellectual property without the written consent of the person shall not use the intellectual property of others, including information protected by copyright and trademark protection, alteration or change of intellectual property rights of others, such as non-copyright text or pictures. Our website will not be any mail sent by members or groups responsible for the content of the discussion thread, any information, goods or services are not responsible for third party or members of. Use our services, you agree that: In the following cases, Our website will not be responsible to you or others: for example: a threat to any party, defamatory, obscene, indecent, attack or offense, or tort, including the illegal use of knowledge property rights. Our website does not have all the information you provide to (including feedback and suggestions), or you publish Our website, download, input or submit all the information ("submitted information"). However, if you posted on our Web site or client, uploading, inputting, providing or submitting information, you indicate that you give Our website perpetual and irrevocable right to transfer, Our website the right to copy, use, store, modify, edit, translate or publish any or all of the information you have submitted, and without payment of royalties information. Our website no obligation to post or use the information you submit and Our website can always decide to delete the information you have submitted. In this website you download, input or submit information that indicates that you have your control over the release of information. For your information is deleted, invalid or failure to store, Our website and its partners will not be held responsible.</div>
          <div class="title2" data-v-85f2ecf4="">9. MEMBER ACCOUNT</div>
          <div class="content" data-v-85f2ecf4="">Once you sign up for our service, you will receive an account number and password, you are responsible for your account and password confidential, and shall be responsible for all activities related to your account. Once registered as a member, you will be responsible for all of your information files. Prohibited publication of pornographic or other obscene content in the file or web service project, because it would threaten your membership. For the next line dating site members Our website, Our website will not take any responsibility. You agree Our website send mail (involving service information (including changes to upgrade), new features or events, use the services of the observations and recommendations) to you.</div>
          <div class="title2" data-v-85f2ecf4="">10. MATERIALS PROTECTED BY COPYRIGHT AND TRADEMARK PROTECTION</div>
          <div class="content" data-v-85f2ecf4="">Content Our website are protected by copyright Copyright © 2011-2022.</div>
          <div class="title2" data-v-85f2ecf4="">11. DISCLAIMER</div>
          <div class="content" data-v-85f2ecf4="">In Our website or published by Our website (or Our website agents or partners) information, according to "existing" and "existing" offer. It does all kinds of express or implied warranties and conditions. Our website does not control any information, products or services provided by third parties. You expressly agree that use of the service will bear the risk alone. The fullest extent permissible pursuant to applicable law: Our website on all express or implied warranties, disclaimers, and such warranty including but not limited to implied merchantability and ensure suitability for special purposes; Our website does not guarantee provided service to meet your needs, does not guarantee the service will be uninterrupted, timely, secure or correct. Our website not for service use and use the results as collateral. Our website does not warrant that this website or services does not contain any viruses or other harmful components. Our website does not warrant or represent that: keep the site transfer information confidential. Our website website does not guarantee the accuracy and completeness of the translation. Our website do not guarantee the following: any goods or services purchased or obtained through this website, or to advertise on this site or sponsorship of goods or services, or any transaction conducted through this website. Information Our website not you receive services from Our website or make any express warranties (whether oral or written).</div>
        </template>
      </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  components: { },
  data() {
    return {
      language: "cn",
      type: ''
    }
  },
  computed:{
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    getLanguage: {
      handler(newV){
        this.changeLang(newV)
      },
      immediate: true
    }
  },
  create() {
  },
  mounted() {
    this.language = this.getLanguage
  },
  methods: {
    changeLang(lang) {
      this.language = lang
    }
  }
};
</script>
<style scoped>
@import "../assets/css/common.css";
.infocontainer {
  width: 100%;
  padding: 20px 10px;
  margin: 5px 0;
  text-align: left;
}
.title1 {
  margin-bottom: 28px;
  font-size: 20px;
}
.title2{
  font-size: 18px;
  line-height: 30px;
}
.title1, .title2, .title3 {
  color: #513b5a;
  font-weight: 700;
}
.content {
  color: #000;
  font-size: 14px;
}
.title1, .title2, .title3 {
  color: #513b5a;
  font-weight: 700;
  margin: 5px 0;
}

.bodycontainer {
  width: 1000px;
}
.bodycontainer .formtitle {
  width: 100%;
  color: #513b5a;
  font-weight: 700;
  margin-top: 50px;
  margin-bottom: 30px;
  font-size: 20px;
}

.bodycontainer .formbody{
  width: 800px;
}
.bodycontainer .formcontent {
  width: 100%;
  word-wrap: break-word;
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 14px;
}
.bodycontainer .boxhead{
  display: flex;
  background: hsla(0,0%,100%,.2) url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==) repeat-x 0 0;
  border: none;
  border-radius: 6px 6px 0 0;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding-left: 10px;
  border: 1px solid hsla(0,0%,100%,.5);
}
.bodycontainer .registtitle {
  color: #513b5a;
  width: 100%;
  padding: 10px;
}
.bodycontainer .formitemtitle{
  color: #fff;
  width: 100%;
  padding: 10px;
  text-align: center;
}
.bodycontainer .boxbody {
  background: hsla(0,0%,100%,.05) url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==) repeat-x 0 0;
  margin-bottom: 10px;
}
.bodycontainer .boxbody .boxitem{
  display: flex;
  width: 100%;
  border-bottom: 1px solid hsla(0,0%,100%,.5);
  border-left: 1px solid hsla(0,0%,100%,.5);
  border-right: 1px solid hsla(0,0%,100%,.5);
}
.bodycontainer .boxbody .boxitem .left {
  width: 20%;
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  color: #fff;
  font-size: 14px;
}
.bodycontainer .boxbody .boxitem .center{
  width: 60%;
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: #fff;
  font-size: 14px;
  border-left: 1px solid hsla(0,0%,100%,.5);
  border-right: 1px solid hsla(0,0%,100%,.5);
}
.bodycontainer .boxbody .boxitem .right{
  width: 20%;
  display: flex;
  padding: 10px;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  color: #fff;
  font-size: 14px;
}
.bodycontainer .formbuttoncontainer{
  width: 100%;
  margin-top: 50px;
  margin-bottom: 20px;
  justify-content: flex-end;
}
.bodycontainer .formbuttoncontainer .loginbtn {
  width: 100px;
  height: 32px;
  background-color: #e8cbed;
  padding: 0 8px;
  border: 1px solid rgba(93,69,110,.6);
  border-radius: 4px;
  color: #513b5a;
  font-size: 14px;
  justify-content: space-between;
  cursor: pointer;
}
</style>
